import './index.css';
import { useParams } from 'react-router-dom';
import { IMAGE_BASE_URL } from '../../utils/constants';
const PaymentCommunication = () => {
  const params = useParams();
  const { lang = 'en' } = params;
  const getImage: { [key: string]: string } = {
    en: `${IMAGE_BASE_URL}en.png`,
    hi: `${IMAGE_BASE_URL}hi.png`,
    mr: `${IMAGE_BASE_URL}mr.png`,
  };
  return (
    <div className='main'>
      <img
        src={getImage[lang] || getImage.en}
        alt='PaymentCommunication'
        className='image'
      />
    </div>
  );
};
export default PaymentCommunication;
